import { Download, FileText } from "lucide-react";
import { Button } from "../../button";

export interface ResponseDetailContentProps {
  response: {
    id: string;
    responderName: string;
    isAdmin: boolean;
    date: string;
    status?: "completed" | "draft";
  };
  responseData?: Array<{
    question: string;
    answer: string;
  }>;
}

export function ResponseDetailContent({ response, responseData = [] }: ResponseDetailContentProps) {
  return (
    <div className="flex flex-col gap-4 h-full">
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">{response.date}</p>
        <div className="flex items-center gap-0">
          <Button size="icon" variant="ghost" hoverLabel="Download PDF">
            <Download />
          </Button>
          <Button size="icon" variant="ghost" hoverLabel="Generate PDF">
            <FileText />
          </Button>
        </div>
      </div>

      <div className="flex flex-col gap-3 overflow-auto p-1">
        {responseData.map((item, index) => (
          <div key={index} className="border-b border-gray-100 pb-3 last:border-b-0">
            <div className="text-sm font-medium text-gray-700 mb-1">{item.question}</div>
            <div className="text-sm text-gray-900">{item.answer}</div>
          </div>
        ))}

        {responseData.length === 0 && (
          <div className="text-center py-8 text-muted-foreground">No response data available.</div>
        )}
      </div>
    </div>
  );
}
